export default __webpack_public_path__ + "static/media/cards_flips_2.5fb14cee.mp3";